export default __webpack_public_path__ + "static/media/Brow_7_C5.12fd67a2.svg";